/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStatus } from '../enums';
import { UserService } from '../services';
import { environment, ModulesEnum } from '../../../environments/environment';

@Injectable()
export class LoginGuard {

    constructor(
        private router: Router,
        private userService: UserService
    ) {
    }

    get environment(): any {
        return environment;
    }

    public canActivate() {
        const userService = this.userService;

        if (userService.hasLocalStorage() && userService.tokenStatus() === TokenStatus.OK && userService.userObjectMatchesModule()) {
            if (this.environment.module === ModulesEnum.CENTRALISED_MANAGEMENT) {
                this.router.navigateByUrl('/cm/dashboard').then();

                return true;
            } else {
                this.router.navigateByUrl(`lb/${userService.getUser('applianceId')}/overview`).then();

                return true;
            }
        } else {
            userService.clearLocalStorage();
            userService.clearSessionStorage();
        }
    }
}
